<template>
  <v-main class="pt-0 main-home">
    <home />
    <about />
    <contact />
  </v-main>
</template>

<script>
import home from "../components/HomeSection";
import about from "../components/AboutSection";
import contact from "../components/ContactSection";

export default {
  name: "HomePage",
  components: { home, about, contact },
  mounted() {
    this.handleScroll();
  },
  watch: {
    "$route.query": {
      handler() {
        this.$nextTick(() => this.handleScroll());
      },
    },
  },
  methods: {
    handleScroll() {
      const to = this.$route.query.scrollTo;
      if (to) {
        this.$vuetify.goTo(to);
      }
    },
  },
};
</script>

<style scoped>
.main-home {
  background-image: url("~@/assets/img/bgMain.png");
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
</style>
